import Promise from 'bluebird';
import AnchorAPIError from './AnchorAPIError';

const fetchPodcastStatus = () =>
  new Promise((resolve, reject) => {
    fetch('/api/podcast/status', {
      credentials: 'same-origin',
    })
      .then(resolve)
      .catch(reject);
  }).then(response => {
    if (response.ok) {
      return response.json();
    }
    if (response.status === 400) {
      throw new AnchorAPIError(response, `Missing image`);
    }
    throw new AnchorAPIError(
      response,
      `Non 200 response status: ${response.status}`
    );
  });

export { fetchPodcastStatus };
